<template>
    <modal name="add-job-modal" @before-open="beforeOpen" :resizable="true" transition="pop-out"
           :width="800"
           :height="575">
        <h4 class="text-center panel-heading">Vacature toevoegen</h4>
        <form @submit.prevent="addJob()">
            <div class="row">
                <div class="col-sm-12">
                    <div class="col-sm-6 mb-20">
                        <label>Nederlandse naam*</label>
                        <input type="text"
                               class="form-control"
                               v-model="job.dutchTitle"
                               required>
                    </div>
                    <div class="col-sm-6 mb-20">
                        <label>Franse naam</label>
                        <input type="text"
                               v-model="job.frenchTitle"
                               class="form-control">
                    </div>
                </div>
            </div>

            <div class="row">
                <div class="col-sm-12">
                    <div class="col-sm-6 mb-20">
                        <label>Nederlandse omschrijving</label>
                        <textarea class="form-control"
                                  rows="8"
                                  v-model="job.dutchDescription"></textarea>
                    </div>
                    <div class="col-sm-6 mb-20">
                        <label>Franse omschrijving</label>
                        <textarea class="form-control"
                                  rows="8"
                                  v-model="job.frenchDescription"></textarea>
                    </div>
                </div>
            </div>

            <div class="row">
                <div class="col-sm-12">
                    <div class="col-sm-4">
                        <button type="submit" class="btn btn-danger">Opslaan</button>
                    </div>
                </div>
            </div>
        </form>
    </modal>
</template>
<script>
    import { mapGetters } from 'vuex'
    import * as types from '../../store/mutation-types'

    export default {
        name: 'AddJob',
        data() {
            return {
                job: {
                    active: true,
                    dutchTitle: '',
                    frenchTitle: '',
                    dutchDescription: '',
                    frenchDescription: ''
                }
            }
        },
        methods: {
            addJob() {
                this.$store.commit(types.SET_JOB_TO_CREATE, this.job)
                this.$store.dispatch('createJob').then(() => {
                    if (this.isJobCreated) {
                        this.job.dutchTitle = ''
                        this.job.frenchTitle = ''
                        this.job.dutchDescription = ''
                        this.job.frenchDescription = ''

                        this.$notify({ group: 'success', type: 'success', title: 'Succes', text: 'Vacature is aangemaakt!' })
                        this.$modal.hide('add-job-modal')
                    }
                })
            },
            beforeOpen(event) {
            }
        },
        computed: {
            ...mapGetters({
                isJobCreated: 'isJobCreated'
            })
        }
    }
</script>

<style scoped>
    .mb-20 {
        margin-bottom: 20px;
    }
</style>
